<template>
  <div class="groupPromocodeCrudComp">

    <div v-if="!groupId">
      <label for="" class="label_nodata">Сначала создайте группу</label>
    </div>

    <div v-if="promocode && groupId" class="div_label">

      <div>
        <label
          class="label_title"
          for=""
        >ID</label>
        <input-comp
          :classInput="'input_grey'"
          :value="promocode.id"
          disabled
        />
      </div>

      <div>
        <label class="label_title" for="">Название</label>
        <input-comp
          :classInput="'input_grey'"
          :value="promocode.name"
          disabled
        />
      </div>

      <div>
        <label class="label_title" for="">Бонус, бал.</label>
        <input-number-comp :classInput="'input_grey'" :value="promocode.bonus" disabled/>
        <p class="p_err_min"></p>
      </div>

      <div>
        <label class="label_title" for="">Скидка, %</label>
        <input-number-comp :classInput="'input_grey'" :value="promocode.sale" disabled/>
        <p class="p_err_min"></p>
      </div>

      <div>
        <button-comp :classBtn="'btn_orange_min'" :textBtn="'Заменить'" :clickBtn="remove"/>
      </div>

    </div>

    <div v-if="groupId && !promocode">
      <!-- <div> -->

      <div>
        <label class="label_title" for="">ID группы</label>
        <input type="text" class="input_grey" :value="groupId" disabled>
        <p class="p_err_min"></p>
      </div>

      <div>
        <label class="label_title" for="">ID промокода</label>
        <input-comp
          :classInput="'input_grey'"
          :value="data.id.value"
          v-model="data.id.value"
          disabled
        />
        <p class="p_err_min"></p>
      </div>

      <div>
        <label class="label_title" for="">Название</label>
        <input-comp
          :disabled="id"
          :classInput="'input_grey'"
          :value="data.name.value"
          v-model="data.name.value"
          v-bind:class="{'animated shake error_input': errors.name}"
          v-on:click.native="resetError('name')"
        />
        <p class="p_err_min">{{errors.name}}</p>
      </div>

      <div>
        <label class="label_title" for="">Бонус, бал.</label>
        <input-number-comp
          :min="0"
          :max="1000000"
          :classInput="'input_grey'"
          :value="Number(data.bonus.value)"
          v-model="data.bonus.value"
          v-bind:class="{'animated shake error_input': errors.bonus}"
          v-on:click.native="resetError('bonus')"
        />
        <p class="p_err_min">{{errors.bonus}}</p>
      </div>

      <div>
        <label class="label_title" for="">Скидка, %</label>
        <input-number-comp
          :min="0"
          :max="100"
          :classInput="'input_grey'"
          :value="Number(data.sale.value)"
          v-model="data.sale.value"
          v-bind:class="{'animated shake error_input': errors.sale}"
          v-on:click.native="resetError('sale')"
        />
        <p class="p_err_min">{{errors.sale}}</p>
      </div>

      <div class="div_btns">
        <button-comp :disabled="id" :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
      </div>

      <p class="p_err_main">{{errMain}}</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'groupPromocodeCrudComp',
  props: {
  },
  data: function () {
    return {
      required: ['id', 'name', 'bonus', 'sale', 'groupId'],
      moduleName: 'promocodes',
      group: {
        moduleName: 'groups'
      }
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {
  },
  computed: {
    id: function () { return this.$store.getters[`${this.moduleName}/getId`] },
    data: function () { return this.$store.getters[`${this.moduleName}/getOne`] },
    errMain: function () { return this.$store.getters[`${this.moduleName}/getErrMain`] },
    errors: function () { return this.$store.getters[`${this.moduleName}/getErrors`] },
    groupId: function () { return this.$store.getters[`${this.group.moduleName}/getId`] },
    promocode: function () { return this.$store.getters[`${this.group.moduleName}/getPromocodeId`] }
  },
  methods: {
    save () {
      this.data.groupId.value = this.groupId
      this.$store.dispatch(`${this.moduleName}/createOrUpdate`, { data: this.data, required: this.required })
    },
    remove () {
      let id = null
      if (this.promocode) {
        id = this.promocode.id
        this.$store.commit(`${this.group.moduleName}/setPromocode`, null)
      };
      this.$store.dispatch(`${this.moduleName}/delete`, { id: id })
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">

.groupPromocodeCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
}
.div_label {
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  text-align: left
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .promocodeCrudComp{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
}

</style>
